import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { DateUtil } from '.'

export class JsonDateInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map((val: HttpEvent<any>) => {
                if (val instanceof HttpResponse) {
                    const body = val.body
                    this.convert(body)
                }
                return val
            }),
        )
    }

    isIsoDateString(value: any): boolean {
        // TODO: We should handle this in the data models instead.
        // This is a hack to get the dates to deserialize correctly.

        if (value === null || value === undefined) {
            return false
        }
        if (typeof value !== 'string') {
            return false
        }

        // Check if string matches ISO 8601 date format patterns
        // Supports: YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss, YYYY-MM-DDTHH:mm:ss.sssZ, etc.
        // Also supports variable-length fractional seconds (1-7 digits)
        // Timezone information (Z or +/-HH:MM) is optional
        const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{1,7})?(Z|[+-]\d{2}:\d{2})?)?$/

        if (!isoDateRegex.test(value)) {
            return false
        }

        const date = new Date(DateUtil.toParseableIso(value))
        return !isNaN(date.getTime())
    }

    convert(body: any) {
        if (body === null || body === undefined) {
            return body
        }
        if (typeof body !== 'object') {
            return body
        }
        for (const key of Object.keys(body)) {
            const value = body[key]
            if (!isNaN(value)) {
                continue
            }
            if (this.isIsoDateString(value)) {
                body[key] = DateUtil.toDate(value)
            } else if (typeof value === 'object') {
                this.convert(value)
            }
        }
    }
}
